import script from "./Co2ValueForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./Co2ValueForm.vue?vue&type=script&lang=ts&setup=true"

import "./Co2ValueForm.vue?vue&type=style&index=0&id=42c23c39&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42c23c39"]])

export default __exports__